export const UPDATE_USER = "UPDATE_USER";
export const PROFILE_PHOTO = "PROFILE_PHOTO";
export const GET_USER = "GET_USER";
